var primary = localStorage.getItem('primary_color') || '#534686';
var secondary = localStorage.getItem('secondary_color') || '#FFA47A';
const charts =
{
    sales:
    {
        options:
        {

            chart: {
                type: "bar",
                height: 100,
                stacked: true,
                stackType: "100%",
                toolbar: {
                    show: false,
                },
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: "40px",
                    borderRadius: 2,
                },
            },
            grid: {
                show: false,
                xaxis: {
                    lines: {
                        show: false,
                    },
                },
            },
            states: {
                hover: {
                    filter: {
                        type: "darken",
                        value: 1,
                    },
                },
            },
            dataLabels: {
                enabled: false,
            },
            legend: {
                show: false,
            },
            colors: [ "#dad8e0",primary],
            xaxis: {
                show: false,
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                labels: {
                    show: false,
                },
            },
            tooltip: {
                marker: {
                    show: false,
                },
                fixed: {
                    enabled: false,
                    position: "bottomRight",
                    offsetX: 0,
                    offsetY: 0,
                },
            },
        },
        series: [{
            name: "Statistics",
            data: [20, 60, 50, 70, 40, 80, 20],
        },
        {
            name: "Statistics",
            data: [80, 40, 50, 30, 60, 20, 20],
        },
        ],
    },
    income:
    {
        options: {

            chart: {
                type: "bar",
                height: 100,
                stacked: true,
                stackType: "100%",
                toolbar: {
                    show: false,
                },
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: "40px",
                    borderRadius: 2,
                },
            },
            grid: {
                show: false,
                xaxis: {
                    lines: {
                        show: false,
                    },
                },
            },
            states: {
                hover: {
                    filter: {
                        type: "darken",
                        value: 1,
                    },
                },
            },
            dataLabels: {
                enabled: false,
            },
            legend: {
                show: false,
            },
            colors: [ "#faded1",secondary],
            xaxis: {
                show: false,
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                labels: {
                    show: false,
                },
            },
            tooltip: {
                marker: {
                    show: false,
                },
                fixed: {
                    enabled: false,
                    position: "bottomRight",
                    offsetX: 0,
                    offsetY: 0,
                },
            },
        },
        series: [
            {
                name: "Statistics",
                data: [20, 60, 50, 70, 40, 80, 20],
            },
            {
                name: "Statistics",
                data: [80, 40, 50, 30, 60, 20, 20],
            },
        ]
    },
    order:{
        options : {

            chart: {
                type: "bar",
                height: 100,
                stacked: true,
                stackType: "100%",
                toolbar: {
                    show: false,
                },
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: "40px",
                    borderRadius: 2,
                },
            },
            grid: {
                show: false,
                xaxis: {
                    lines: {
                        show: false,
                    },
                },
            },
            states: {
                hover: {
                    filter: {
                        type: "darken",
                        value: 1,
                    },
                },
            },
            dataLabels: {
                enabled: false,
            },
            legend: {
                show: false,
            },
            colors: ["#dad8e0",primary ],
            xaxis: {
                show: false,
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                labels: {
                    show: false,
                },
            },
            tooltip: {
                marker: {
                    show: false,
                },
                fixed: {
                    enabled: false,
                    position: "bottomRight",
                    offsetX: 0,
                    offsetY: 0,
                },
            },
        },
            series: [
                {
                    name: "Statistics",
                    data: [20, 60, 50, 70, 40, 80, 20],
                },
                {
                    name: "Statistics",
                    data: [80, 40, 50, 30, 60, 20, 20],
                },
            ]
        },
        visitors:{
        options :{
            
            chart: {
              type: "bar",
              height: 100,
              stacked: true,
              stackType: "100%",
              toolbar: {
                show: false,
              },
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "40px",
                borderRadius: 2,
              },
            },
            grid: {
              show: false,
              xaxis: {
                lines: {
                  show: false,
                },
              },
            },
            states: {
              hover: {
                filter: {
                  type: "darken",
                  value: 1,
                },
              },
            },
            dataLabels: {
              enabled: false,
            },
            legend: {
              show: false,
            },
            colors: [ "#faded1",secondary],
            xaxis: {
              show: false,
              labels: {
                show: false,
              },
              axisBorder: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
            },
            yaxis: {
              labels: {
                show: false,
              },
            },
            tooltip: {
              marker: {
                show: false,
              },
              fixed: {
                enabled: false,
                position: "bottomRight",
                offsetX: 0,
                offsetY: 0,
              },
            },
          },
          series: [
            {
              name: "Statistics",
              data: [20, 60, 50, 70, 40, 80, 20],
            },
            {
              name: "Statistics",
              data: [80, 40, 50, 30, 60, 20, 20],
            },
          ],
        },
        recent: {
            options : {

                chart: {
                    height: 355,
                    type: "area",
                    toolbar: {
                        show: false,
                    },
                    dropShadow: {
                        enabled: true,
                        left: 8,
                        blur: 0,
                        color: secondary,
                        opacity: 0.1,
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    curve: "smooth",
                    width: [5, 0],
                    colors: [secondary, primary],
                },

                grid: {
                    borderColor: "#3f3a591a",
                },

                fill: {
                    type: "solid",
                    opacity: [1, 0.2],
                },
                tooltip: {
                    marker: {
                        show: false,
                    },
                    fixed: {
                        enabled: false,
                        position: "bottomRight",
                        offsetX: 0,
                        offsetY: 0,
                    },
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function (y) {
                            if (typeof y !== "undefined") {
                                return y.toFixed(0) + " k";
                            }
                            return y;
                        },
                    },
                },
                xaxis: {
                    type: "month",
                    categories: ["Jan", "Feb", "Mar", "April", "May", "June", "July"],
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                    },
                    crosshairs: {
                        show: true,
                        width: 50,
                        position: "back",
                        opacity: 0.2,
                        stroke: {
                            color: secondary,
                            width: 0,
                            dashArray: 0,
                        },

                        fill: {
                            type: "solid",
                            color: secondary,
                        },
                    },
                    tooltip: {
                        marker: {
                            show: false,
                        },
                        show: false,
                        enabled: false,
                    },
                },
                legend: {
                    show: false,
                },
                responsive: [{
                        breakpoint: 1661,
                        options: {
                            chart: {
                                height: 357,
                            },
                        },
                    },
                    {
                        breakpoint: 575,
                        options: {
                            chart: {
                                height: 280,
                            },
                        },
                    },

                    {
                        breakpoint: 400,
                        options: {
                            chart: {
                                height: 230,
                            },
                        },
                    },
                ],
                colors: [secondary, primary],
            },
            series: [{
                    type: "line",
                    data: [150, 470, 250, 380, 100, 480, 420],
                },
                {
                    type: "area",
                    data: [220, 160, 230, 150, 220, 130, 200],
                },
            ],
        },
        
    

    }
export default charts;

